<template>
  <v-card>
    <v-card-title>
      Gestione Scala-Taglie su Prodotto
    </v-card-title>    
    <v-card-subtitle>
      <v-row>
        <v-col :lg="4" :md="6" :sm="5">
          <v-select
            v-model="tipoInput"
            :items="tipiInput"
            item-text="descrizione"
            item-value="codice"
            :outlined="true"
            label="Tipo gestione"
            clearable
            dense
          />
        </v-col>
        <v-col>
          <v-switch v-model="coloreSuRighe" inset label="Colore su Righe" class="mt-1"></v-switch>
        </v-col>
       <!--  <v-spacer></v-spacer> -->
      </v-row>
      <v-row dense>
        <v-col :lg="6">
          <v-autocomplete
            v-model="prodotto"
            :loading="loading"
            :items="items"
            :search-input.sync="searchProdotto"
            :label="'Prodotto'"
            cache-items
            no-data-text="Cerca un prodotto per codice o descrizione (% cerca fulltext)"
            item-text="testo"
            item-value="codice"
            clearable
            dense
            hide-details="auto"
            :outlined="true"
            :return-object="true"
            @change="onchange"
            @click:clear="clear"
          >
            <template v-slot:[`selection`]="{ item }">
              {{ item.codice + ' - ' + item.descrizione }}
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>   
    </v-card-subtitle>
    <!-- :codiceProdotto="'1027C2044'"  00j4lc0iajhk100 -->
    <dettaglio-scala :tipoInput="tipoInput" :coloreSuRighe="coloreSuRighe" :codiceProdotto="codiceProdotto" :mostraValoreUnico="true" :refresh="triggerRefresh" @change="salvaDati"></dettaglio-scala>
  </v-card>
</template>

<script>
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import prodotti from '@/services/prodottiService.js'
  import configurazioni from '@/services/configurazioniService.js'
  import magazzino from '@/services/magazzinoService.js'
  import DettaglioScala from './dettaglioScala'
  
  export default {
    components: {
      DettaglioScala
    },
    mixins: [ verificaLicenza ],
    data () {
      return {
        tipoInput: 'giacenza',
        coloreSuRighe: true,
        tipiInput: [],
        loading: false,
        debounceSearch: null,
        searchProdotto: '',
        prodotto: null,
        items: [],
        triggerRefresh: 1
      }
    },
    async created() {
      this.debounceSearch = _.debounce(this.searchProdottoDeb, 500)
    },
    watch: {
      async searchProdotto(val) {
        await this.debounceSearch(val)
      }
    },
    async mounted() {
      await this.gestioneToken()
      const scala_taglie = await configurazioni.getConfigurazione('scala_taglie')
      this.tipiInput = scala_taglie.tipiInput || []
/*       this.tipiInput = [
        { codice: 'giacenza', descrizione: 'Giacenza' },
        { codice: 'quantita', descrizione: 'Carico Quantità' },
        { codice: 'prezzo.L1.base', descrizione: 'Listino L1' },
        { codice: 'prezzo.L2.base', descrizione: 'Listino L2' }
      ] */
    },
    computed: {
      codiceProdotto() {
        const codice = this.prodotto && this.prodotto.codice
        return codice
      },
      magazziniMultipli() {
        return this.$store.getters['magazzini/magazziniMultipli']
      },
      magazzinoSelezionato() {
        return this.$store.getters['magazzini/codiceMagazzino']
      }      
    },
    methods: {
      async searchProdottoDeb(val) {
        if (val) {
          await this.querySelections(val)
        }
      },
      async querySelections (val) {
        this.loading = true
        var cp, testo
        let prefisso = ''
        
        testo = val && val.startsWith('%') ? val.substring(1).trim() : val

        let filtri = {
          id: testo,
          codice: testo
        }
        if (val && val.startsWith('%')) {
          filtri.testo = testo
          prefisso = '%'
        } else {
          filtri.descrizione = testo
          filtri.barcode = testo // verificare
        }
        const opzioni =  {
          itemsPerPage: 50
        }
        // TODO: Deve prendere i codici prodotto (o i codici originali, es Benetton), non gli _id
        // Considerare anche ricerca per barcode --> prendo il codice associato ad un prodotto specifico e ricostruisco tutta la scala taglie
        const data = await prodotti.getFilteredProducts(filtri, opzioni)
        cp = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : []
       
        const itm = _.uniqBy(cp, 'ricercaTC').map(x => {
          const v1 = _.get(x, 'varianti.variante1', {})
          const v2 = _.get(x, 'varianti.variante2', {})

          let descPrefisso = x.descrizione
          if (prefisso) {
            const idx = x.descrizione.toLowerCase().indexOf(testo.toLowerCase())
            const len = testo.length
            if (idx !== -1) {
              descPrefisso = x.descrizione.substring(0, idx) + val + x.descrizione.substring(idx + len)
            }
          }
          return { 
            // testo: (`${this.prependMarchio ? (x.marchio || '') + ': ' : ''}${x.codice} - ${descPrefisso} ${_.get(x, 'varianti.variante2.descrizione', '')} ${_.get(x, 'varianti.variante1.descrizione', '')} ${ this.isBarcode ? '-' + x.ricercaBarcode : ''}`).trim(),
            testo: (`${this.prependMarchio ? (x.marchio || '') + ': ' : ''}${x.codice} - ${descPrefisso} ${ this.isBarcode ? '-' + x.ricercaBarcode : ''}`).trim(),
            id: x._id,
            codice: x.codice,
            // descrizione: (`${x.descrizione} ${_.get(x, 'varianti.variante2.descrizione', '')} ${_.get(x, 'varianti.variante1.descrizione', '')}`).trim(),
            descrizione: (`${x.descrizione}`).trim(),
            prezzo: x.prezzo && x.prezzo.L1 && x.prezzo.L1.base, // TODO: Prendere listino di default da configurazione (su store..)
            prezzo2: x.prezzo && x.prezzo.L2 && x.prezzo.L2.base,
            prezzoItem: x.prezzo,
            acquisto: x.magazzino && x.magazzino.prezzoAcquisto,
            variante1: v1,
            variante2: v2,
            datiFiscali: x.datiFiscali || {},
            item: x
          }
        })
        this.items = itm
        this.loading = false
      },
      onchange(prodotto) {
        this.prodotto = prodotto
      },
      clear() {
      },
      async salvaDati(payload) {
        console.log(payload)
        switch (this.tipoInput) {
          case 'giacenza':
            await this.aggiorna(payload, 'rettifica')
            break
          case 'quantita':
            await this.aggiorna(payload, 'carico')
            break
          default:
            // Aggiorna solo il prodotto
            await this.aggiorna(payload, this.tipoInput)
            break
        }
        await prodotti.clearCache()
        this.triggerRefresh++
      },
      async aggiorna(payload, tipo) {
        for (let c of payload.scala.colori) {
          let valori = payload.valori[c.codice]
          for (let t of payload.scala.taglie) {
            if (!valori[String(t.codice)]) {
              continue
            }
            const valore = +parseFloat(valori[t.codice] || 0).toFixed(2)
            const id = prodotti.creaCampoRicercaTC_Codici(payload.codiceProdotto, t.codice, c.codice)
            let prodotto = await prodotti.getProdotto(id)
            if (!prodotto) {
              continue
            }
            switch (tipo) {
              case 'rettifica':
                await this.aggiornaGiacenzaProdotto(prodotto, valore)
                break
              case 'carico':
                await this.caricaGiacenzaProdotto(prodotto, valore)
                break
              default:
                await this.aggiornaProdotto(tipo, prodotto, valore)
                break
            }
          }
        }
      },
      calcolaGiacenza(prodotto) {
        let giacenza = prodotto.magazzino.giacenza || 0
        if (this.magazziniMultipli) {
          const giacenzaParziale = _.get(prodotto, 'magazzino.giacenzaParziale', null)
          if (typeof giacenzaParziale === 'object' && !_.isEmpty(giacenzaParziale)) {
            const gg = giacenzaParziale[this.magazzinoSelezionato] || {}
            giacenza = gg.giacenza || 0
          }
        }
        return +parseFloat(giacenza).toFixed(2)
      },
      async aggiornaGiacenzaProdotto(prodotto, valore) {
        const giac = this.calcolaGiacenza(prodotto)
        const delta = +(valore - giac).toFixed(2)
        if (delta !== 0) {
          let rettifica = {
            idProdotto: prodotto._id,
            delta: delta,
            valore: valore,
            tipoMovimento: 'rettifica',
            magazzino: this.$store.getters['magazzini/codiceMagazzino']
          }
          prodotto.magazzino.giacenzaParziale = prodotto.magazzino.giacenzaParziale || {}
          let mg = prodotto.magazzino.giacenzaParziale
          mg[rettifica.magazzino] = mg[rettifica.magazzino] || {}
          mg[rettifica.magazzino].giacenza = +valore.toFixed(2)
          mg[rettifica.magazzino].valore = +(mg[rettifica.magazzino].giacenza * (prodotto.magazzino.prezzoAcquisto || 0)).toFixed(2)    
          let totG = 0
          let totV = 0
          for (let gg of Object.keys(mg)) {
            totG += mg[gg].giacenza
            totV += mg[gg].valore
          }
          prodotto.magazzino.giacenza = +totG.toFixed(2)
          prodotto.magazzino.valore = +totV.toFixed(2)
          await prodotti.aggiornaProdotto(prodotto)
          await magazzino.creaMovimentoRettificaGiacenza(rettifica)        
        }
      },
      async caricaGiacenzaProdotto(prodotto, quantita) {
        const giac = this.calcolaGiacenza(prodotto)
        if (quantita !== 0) {
          const data = new Date()
          let movimento = {
            data: data,
            magazzino: this.$store.getters['magazzini/codiceMagazzino'],
            prodotto: { codice: prodotto._id, um: prodotto.unitaMisura, lotti: [], quantita: quantita },
            quantita: quantita,
            valore: +(quantita * (prodotto.magazzino.prezzoAcquisto || 0)).toFixed(2),
            tipo: 'carico',
            causale: 'carico',
            
            anagrafica: { clienti: null, fornitore: null },
            riferimento: { tipo: 'scalaTaglie', data: data }
          }
          await magazzino.creaMovimenti(movimento)
        }
      },
      async aggiornaProdotto(tipo, prodotto, valore) {
        if (_.get(prodotto, tipo) !== valore) {
          _.set(prodotto, tipo, valore)
          await prodotti.aggiornaProdotto(prodotto)
        }
      }  
    }
  }
</script>
